import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from './Dialog';
import { Button } from './Button';
import { Loader2 } from 'lucide-react';

interface SimpleDialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  title?: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode | null;
  onOk?: () => void;
  onCancel?: () => void;
  okText?: string;
  cancelText?: string;
  confirmLoading?: boolean;
  width?: number | string;
  className?: string;
}

const SimpleDialog: React.FC<SimpleDialogProps> = ({
  open = false,
  onOpenChange,
  title,
  description,
  children,
  footer,
  onOk,
  onCancel,
  okText = 'OK',
  cancelText = 'Zrušit',
  confirmLoading,
  width,
  className,
}) => {
  const handleOpenChange = (value: boolean) => {
    onOpenChange?.(value);
    if (!value) onCancel?.();
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        className={className}
        style={width ? { maxWidth: width, width: '100%' } : undefined}
      >
        {title && (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogHeader>
        )}
        <div
          className="p-5 overflow-y-auto flex-1 min-h-0"
          style={{ maxHeight: 'calc(85vh - 130px)' }}
        >
          {children}
        </div>
        {footer !== null && (
          <DialogFooter>
            {footer !== undefined ? (
              footer
            ) : (
              <>
                <Button data-testid="simple-dialog-cancel-btn" variant="outline" onClick={onCancel}>
                  {cancelText}
                </Button>
                <Button data-testid="simple-dialog-ok-btn" onClick={onOk} disabled={confirmLoading}>
                  {confirmLoading && <Loader2 className="h-4 w-4 animate-spin" />}
                  {okText}
                </Button>
              </>
            )}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};

export { SimpleDialog };
